<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <OrfEval orfName="salutation"
             :orfType="registeringPersonType">
        <template v-slot:default="{required}">
            <OrfEval :doNotHide="true"
                     orfName="name"
                     :orfType="registeringPersonType">
                <template v-slot:default="{hidden}">
                    <CardSelect type="radio"
                                v-model="person.salutation"
                                :required="required"
                                :name="hidden ? $t('eventRegistration.person.sex') : $t('eventRegistration.person.salutation')"
                                :fixedWidthSm="true">
                        <CardSelectItem
                            v-for="salutation in salutations"
                            :value="salutation.title"
                            :key="salutation.title">
                            {{ salutation.title }}
                        </CardSelectItem>
                    </CardSelect>
                </template>
            </OrfEval>
        </template>
    </OrfEval>
</template>

<script>
import OrfEval from "@/components/pages/registration/OrfEval";
import formSelectChoiceMixin from "@/mixins/registration/formSelectChoiceMixin";
import registrationPersonMixin from "@/mixins/registration/registrationPersonMixin";
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";

export default {
    name: "ParticipantSalutation",
    mixins: [registrationPersonMixin, formSelectChoiceMixin, registrationOnlineRegistrationFieldsMixin],
    components: {OrfEval},
    props: {
        registeringPersonType: {
            required: true,
            type: String,
            description: "participant or invoiceRecipient"
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
